import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import { useParams } from "react-router";

const CreateDeliveryChargeComponent = loadable(
  () => import("../../components/DeliveryCharge/CreateDeliveryCharge")
);
const CreateDeliveryCharge = () => {
  const { templateID } = useParams()
  const { mutateAsync, isPostLoading  } = usePostHook({
    queryKey: ["delivery-charge"],
    navigateURL: `/delivery-charge/${templateID}`,
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.DELIVERY_CHARGE}`;
    let formData = {
      ...values,
      delivery_charge_template: templateID
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Delivery Charge</span>
      </div>
      <CreateDeliveryChargeComponent 
      isLoading={isPostLoading}
      handleCreate={handleCreate}
       />
    </>
  );
};

export default CreateDeliveryCharge
